<!--
 * @Author: 汪俊洪
 * @Date: 2021-10-09 10:17:35
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2024-02-27 19:25:19
 * @Description:
-->
<template>
  <div class="page app-table">
    <div class="inner column">
      <Info :detail="detail" />
      <div class="btns border-bottom">
        <el-button
          v-if="detail.isCanCancel"
          size="small"
          type="danger"
          plain
          @click="cancelVisible = true"
          >取消</el-button
        >
        <el-badge
          class="ossIdsLen"
          :class="{ 'mgl-0': !detail.isCanCancel }"
          :value="ossIdsLen > 0 ? ossIdsLen : null"
        >
          <el-button size="small" @click="ossIdsVisible = true">下载附件</el-button>
        </el-badge>
      </div>
      <div class="content">
        <!-- 发票抬头 开始 -->
        <ClientInfo :detail="detail" />
        <!-- 开票主体 开始 -->
        <SellerInfo :detail="detail" />
        <!-- 开票主体 结束 -->
        <div>
          <h2 class="title mgt-12">订单明细</h2>
          <OrderItem :list="detail.invoiceApplyOrderVoList" />
        </div>
        <div>
          <h2 class="title">开票明细</h2>
          <InvoiceItem
            :list="detail.invoiceApplyOrderItemVoList"
            :detail="detail"
          />
        </div>
      </div>
    </div>
    <!-- 附件 -->
    <el-dialog
      :visible.sync="ossIdsVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="附件"
      width="773px"
    >
      <Enclosure
        v-if="ossIdsVisible"
        :isAdd="false"
        :showUpload="detail.invoiceApplyStatus !== '6'"
        @cancel="ossIdsVisible = false"
        :enclosureInfo="enclosureInfo"
        @afterSearch="(v) => (ossIdsLen = v)"
      />
    </el-dialog>
    <!-- 取消开票 -->
    <el-dialog title="取消开票" :visible.sync="cancelVisible" width="667px">
      <CancelInvoice
        v-if="cancelVisible"
        @submit="cancelOrder"
        @close="cancelVisible = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import Info from './detailComponents/info.vue'
import ClientInfo from './detailComponents/clientInfo.vue'
import SellerInfo from './detailComponents/sellerInfo.vue'
import OrderItem from './detailComponents/orderItem.vue'
import InvoiceItem from './detailComponents/invoiceItem.vue'
import Enclosure from '@/components/enclosure/index.vue'
import CancelInvoice from './detailComponents/cancelInvoice.vue'
import { Base64 } from 'js-base64'

export default {
  name: 'invoice-detail',
  components: {
    Info,
    ClientInfo,
    SellerInfo,
    OrderItem,
    InvoiceItem,
    Enclosure,
    CancelInvoice
  },
  data () {
    return {
      invoiceApplyId: '',
      detail: {},
      loading: false,
      ossIdsVisible: false, // 附件
      ossIdsLen: [],
      cancelVisible: false, // 取消发票
      enclosureInfo: {
        searchUrl: '/front/oms/shopping/invoiceApply/selectFileList',
        addUrl: '/front/oms/shopping/invoiceApply/uploadFile',
        deleteUrl: '/front/oms/shopping/invoiceApply/deleteFile',
        extra: {
          invoiceApplyId: ''
        },
        listAliOssKey: 'invoiceApplyOssId'
      }
    }
  },
  created () {
    this.getDetail()
  },
  methods: {
    // 获取详情
    getDetail () {
      this.invoiceApplyId = Base64.decode(
        this.$route.query.invoiceApplyId || ''
      )
      let url = `/front/oms/shopping/invoiceApply/detail/${this.invoiceApplyId}`
      this.$http.get(url).then(({ data: res }) => {
        if (res.code === 0) {
          this.detail = res.data
          this.enclosureInfo.extra.invoiceApplyId = res.data.invoiceApplyId
          this.getAttachments()
        }
      })
    },
    // 取消开票
    cancelOrder (input) {
      const obj = {
        invoiceApplyId: this.detail.invoiceApplyId,
        ...input
      }
      this.$http
        .post('/front/oms/shopping/invoiceApply/cancel', obj)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success(res.message)
            this.cancelVisible = false
            this.getDetail()
          }
        })
        .catch(() => {})
    },
    // 获取附件数量
    getAttachments () {
      const obj = {
        invoiceApplyId: this.detail.invoiceApplyId
      }
      this.$http
        .post('/front/oms/shopping/invoiceApply/selectFileList', obj)
        .then(({ data: res }) => {
          if (res.code === 0 && res.data) {
            this.ossIdsLen = res.data.length
          }
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  padding-top: 0;
  width: 100%;
  .inner {
    height: 100%;
    padding: 15px;
    background: #fff;
  }
  .content {
    flex: 1;
    overflow: auto;
  }
}
.title {
  margin: 24px 0 12px;
  font-size: 14px;
  font-weight: 700;
  color: #303133;
  &.mgt-12 {
    margin-top: 12px;
  }
  a {
    font-size: 12px;
    font-weight: normal;
  }
}
.btns {
  padding: 6px 0 12px;
  .ossIdsLen {
    margin: -3px 12px 0 12px;
    &.mgl-0 {
      margin-left: 0;
    }
  }
}
::v-deep .el-descriptions__header {
  margin-top: 12px;
}
::v-deep .el-descriptions__title {
  font-size: 14px;
}
.border-bottom {
  border-bottom: 1px solid #ebeef5;
}
</style>
